module.exports = __webpack_public_path__ + "img/angle-right.f2796c37.svg";